<template>
    <div>
        <r-button @click="toggleModal('Contact')" type="link" :disabled="isLoading">{{title}}</r-button>
        <v-modal v-if="showContactModal"
                 title="Edit Contact"
                 @close="toggleModal('Contact')"
                 size="large"
                 :scroll="true"
                 class="contact-modal">
            <div slot="content">
                <v-error-messages
                    :has-frontend-errors="$v.contact.$error"
                    class="stack-l">
                    <li>Contact requires at least one email or phone number</li>
                </v-error-messages>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <r-input label="First Name" v-model="contact.firstName"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input label="Last Name" v-model="contact.lastName"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input label="Address Line 1" v-model="contact.address"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input label="Address Line 2" v-model="contact.address2"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input label="City" v-model="contact.city"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <v-select
                            label="Country"
                            :options="countryList"
                            :show-labels="false"
                            :allow-empty="false"
                            placeholder="Select Country"
                            v-model="contact.country"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <span v-if="hasRegion">
                            <v-select
                                label="Region (state or province)"
                                :options="regionNames"
                                optionLabel="regionName"
                                optionKey="regionCode"
                                :show-labels="false"
                                :allow-empty="false"
                                placeholder="Select Region"
                                v-model="contact.region"/>
                        </span>
                        <r-input
                            v-else
                            label="Region (state or province)"
                            v-model="contact.region"
                        />
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input label="Postal Code" v-model="contact.postalCode"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input label="Organization" v-model="contact.organization"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <contact-phones-emails
                            ref="phonesEmails"
                            :hasError="$v.contact.$error"
                            v-model="contact"/>
                    </div>
                </div>
            </div>
            <template slot="left-actions" v-if="canDelete">
                <r-button type="danger" @click="toggleModal('Delete')">Delete contact</r-button>
            </template>
            <template slot="right-actions">
                <r-button class="inline-s" @click="toggleModal('Contact')">Cancel</r-button>
                <r-button type="primary" @click="save">Save</r-button>
            </template>
        </v-modal>
        <!-- Delete Contact Confirmation Modal -->
        <v-modal v-if="showDeleteModal" title="Delete Contact"
            size="small" @close="toggleModal('Delete')">
            <div slot="content">
                <p>Are you sure you want to delete this contact?</p>
            </div>
            <template slot="actions">
                <r-button type="danger" @click="deleteContact">Delete Contact</r-button>
            </template>
        </v-modal>
    </div>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {
        vErrorMessages, vIcon, vIconButton, vRadio, vSelect,
    } from '@/components/form/index';
    import ContactModel from '@/common/models/contact-model';
    import {COUNTRIES_LIST} from '@/data/countries';
    import REGIONS from '@/data/regions';
    import ContactPhonesEmails from './contact-phones-emails';

    export default {
        name: 'v-contact-form-modal',
        components: {
            vSelect,
            vModal,
            vIcon,
            vRadio,
            vIconButton,
            vErrorMessages,
            ContactPhonesEmails,
        },
        props: {
            value: Object,
            title: String,
            customFields: Array,
            canDelete: {
                type: Boolean,
                default: true,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                countryList: COUNTRIES_LIST,
                regionList: REGIONS,
                contact: new ContactModel(this.value),
                showContactModal: false,
                showDeleteModal: false,
            };
        },
        computed: {
            regionNames() {
                return this.regionList[this.contact.country];
            },
            hasRegion() {
                return ['CA', 'US'].includes(this.contact.country);
            },
        },
        watch: {
            value() {
                this.contact = new ContactModel(this.value);
            },
        },
        validations: {
            contact: {
            },
        },
        methods: {
            toggleModal(type) {
                if (!this[`show${type}Modal`]) {
                    this.contact = new ContactModel(this.value);
                }
                this[`show${type}Modal`] = !this[`show${type}Modal`];
            },
            save() {
                this.$v.$touch();
                const isValid = this.$refs.phonesEmails.validate() && !this.$v.$invalid;
                if (isValid) {
                    this.showContactModal = false;
                    this.$emit('input', this.contact);
                }
            },
            deleteContact() {
                this.showDeleteModal = false;
                this.showContactModal = false;
                this.$emit('input', this.contact, false);
            },
        },
    };
</script>
